import React from "react";
import { getPaginationDisplay } from "../../utils/paginatedList";

/**
 * Server-side list footer: showing X–Y of Z + page controls.
 */
export default function ListPagination({
  currentPage,
  totalCount,
  entriesPerPage = 10,
  onPageChange,
  className = "",
}) {
  const { totalPages, indexOfFirstEntry, indexOfLastEntry } = getPaginationDisplay(
    currentPage,
    entriesPerPage,
    totalCount
  );

  if (totalCount === 0) {
    return (
      <div className={`d-flex align-items-center justify-content-between px-3 py-3 border-top ${className}`}>
        <span className="small text-muted">No entries</span>
      </div>
    );
  }

  const pageNumbers = [];
  const maxButtons = 7;
  let start = Math.max(1, currentPage - Math.floor(maxButtons / 2));
  let end = Math.min(totalPages, start + maxButtons - 1);
  start = Math.max(1, end - maxButtons + 1);
  for (let i = start; i <= end; i += 1) {
    pageNumbers.push(i);
  }

  return (
    <div
      className={`d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 px-3 py-3 border-top ${className}`}
    >
      <span className="small text-muted text-center text-md-start">
        Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalCount} entries
      </span>
      <ul className="pagination mb-0 justify-content-center">
        <li className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}>
          <button
            type="button"
            className="page-link"
            disabled={currentPage <= 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
        </li>
        {pageNumbers.map((n) => (
          <li key={n} className={`page-item ${n === currentPage ? "active" : ""}`}>
            <button type="button" className="page-link" onClick={() => onPageChange(n)}>
              {n}
            </button>
          </li>
        ))}
        <li className={`page-item ${currentPage >= totalPages ? "disabled" : ""}`}>
          <button
            type="button"
            className="page-link"
            disabled={currentPage >= totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
}
